<script lang="ts">
	import { browser } from '$app/environment';
	import { isDarkMode } from '$lib/stores/dark-mode';
	import { themeStore } from '$lib/stores/theme';
	import { onMount } from 'svelte';

	function getBodyElement() {
		return document.getElementsByTagName('body')[0];
	}

	const updateDarkModeStore = () => {
		isDarkMode.set(getBodyElement()?.classList.contains('dark'));
	};

	// Detect system theme
	const toggleDarkMode = () => {
		if ($themeStore === 'system') {
			document.body.classList.toggle(
				'dark',
				window.matchMedia('(prefers-color-scheme: dark)').matches
			);
		}
	};

	onMount(() => {
		if (!browser) {
			return;
		}

		window
			.matchMedia('(prefers-color-scheme: dark)')
			.addEventListener('change', toggleDarkMode);

		toggleDarkMode();
		updateDarkModeStore();

		const bodyElement = getBodyElement();
		if (!bodyElement) {
			return;
		}

		// Make a mutation observer to watch for class changes on body element
		// and update the store accordingly
		const darkModeObserver = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.attributeName === 'class') {
					updateDarkModeStore();
				}
			});
		});

		// Observe changes to the class attribute of the body element
		darkModeObserver.observe(bodyElement, {
			attributes: true
		});

		return () => {
			darkModeObserver.disconnect();

			window
				.matchMedia('(prefers-color-scheme: dark)')
				.removeEventListener('change', toggleDarkMode);
		};
	});
</script>
